import { StackProps } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { EmptyResultIcon } from '@zorro/shared/assets';
import { Box, Flex, Stack, Text, brand } from '@zorro/web/design-system';
import { ElementType, ReactElement } from 'react';

type Props = {
  title: string;
  subTitle: string | ReactElement;
  Icon?: ElementType;
  withMagnifyingGlass?: boolean;
} & StackProps;

export const EmptyResult = ({
  title,
  subTitle,
  Icon = EmptyResultIcon,
  withMagnifyingGlass = true,
  ...rest
}: Props) => {
  return (
    <Stack align="center" pt="4rem" gap="xs" {...rest}>
      <Box pos="relative">
        <Icon />
        {withMagnifyingGlass && (
          <Box
            pos="absolute"
            w="28px"
            h="28px"
            bg="zorroGray.8"
            style={{ borderRadius: '50%' }}
            bd="1px solid white"
            right={0}
            bottom="-1rem"
          >
            <Flex h="inherit" justify="center" align="center">
              <IconSearch size="1.125rem" stroke="zorroGray.4" />
            </Flex>
          </Box>
        )}
      </Box>
      <Text fw={600} pt="1.25rem">
        {title}
      </Text>
      {typeof subTitle === 'string' ? (
        <Text fz="0.875rem" c={brand.zorroGray400}>
          {subTitle}
        </Text>
      ) : (
        subTitle
      )}
    </Stack>
  );
};
